// extracted by mini-css-extract-plugin
export var link = "_tm-0";